import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environmentCommon } from 'src/environments/environment-common';
import { URLS } from '../../../../data/navigation/navigation.data';
import { THEMES } from '../../../../data/product/product.data';
import { Product, paidListingName, resolvePaidListing } from '../../../../model/product/product.model';

/**
 * The privacy policy of a paid theme listing, addressed exactly like the
 * licence page: /theme/privacy?platform=<platform>&product=<key>. The bundle
 * and the standalone premium plugins share one policy (a theme plugin handles
 * no data at all), so only the heading names the plugin; combos without a
 * paid listing go to not-found (resolvePaidListing).
 */
@Component( {
  selector: 'app-theme-privacy-page',
  templateUrl: './theme-privacy-page.component.html',
  styleUrls: [ './theme-privacy-page.component.scss' ]
} )
export class ThemePrivacyPageComponent implements OnInit, OnDestroy {

  URLS = URLS;

  environmentCommon = environmentCommon;

  product: Product | undefined;
  platformName = '';

  private routeSub: Subscription | undefined;

  constructor( private route: ActivatedRoute, private router: Router ) {
  }

  ngOnInit(): void {
    this.routeSub = this.route.queryParams.subscribe( params => {
      const productKey = ( params.product || '' ).toLowerCase();
      const product = THEMES
        .map( line => line.products )
        .reduce( ( acc, val ) => acc.concat( val ), [] )
        .find( p => p.key === productKey );
      const resolved = resolvePaidListing( product, params.platform );
      if ( !resolved ) {
        this.router.navigate( [ URLS.notFound ] );
        return;
      }
      this.product = product;
      this.platformName = resolved.platformName;
    } );
  }

  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
  }

  /** The heading: "All In One Themes Privacy Policy", "Ocean Theme Privacy Policy". */
  get title(): string {
    return this.product ? `${ paidListingName( this.product ) } Privacy Policy` : 'Theme Privacy Policy';
  }
}
